import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api';
import { saveToken, saveAdmin, isAuthenticated } from '../auth';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [sessionToken, setSessionToken] = useState(null);
  const [requires2FA, setRequires2FA] = useState(false);
  const [twoFactorType, setTwoFactorType] = useState('authenticator');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Если уже авторизован, перенаправляем на дашборд
    if (isAuthenticated()) {
      navigate('/');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(username, password);
      
      if (response.data.requires_2fa) {
        // Требуется 2FA
        setRequires2FA(true);
        setSessionToken(response.data.session_token);
        setTwoFactorType(response.data.two_factor_auth_type);
      } else {
        // Авторизация успешна
        saveToken(response.data.access_token);
        saveAdmin(response.data.admin);
        navigate('/');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка авторизации');
    } finally {
      setLoading(false);
    }
  };

  const handle2FAVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.verify2FA(sessionToken, token);
      
      // Авторизация успешна
      saveToken(response.data.access_token);
      saveAdmin(response.data.admin);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Неверный код 2FA');
    } finally {
      setLoading(false);
    }
  };

  if (requires2FA) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2>Двухфакторная аутентификация</h2>
          <p>Введите код из приложения-аутентификатора:</p>
          <form onSubmit={handle2FAVerify}>
            <div className="form-group">
              <input
                type="text"
                placeholder="6-значный код"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                maxLength={6}
                required
                className="form-control"
                autoFocus
              />
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Проверка...' : 'Подтвердить'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setRequires2FA(false);
                setSessionToken(null);
                setToken('');
              }}
            >
              Назад
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Админ-панель</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Имя пользователя</label>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="form-control"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-control"
            />
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;


